<template>
    <div class="my-wechat">
        <mt-header fixed title="新增供应商">
            <router-link to="/my" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <mint-select selectLabel="*类别" selectPatch="type" :selectValue="type" :slots="typeSlots" @changeValue="changeValue"></mint-select>
            <mt-field label="*名称" placeholder="请输入供应商名称" v-model="name"></mt-field>
            <mt-field label="联系方式" placeholder="请输入供应商联系方式" v-model="phone"></mt-field>
            <mt-field label="备注" placeholder="请输入供应商备注" type="textarea" v-model="ps"></mt-field>

            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="createSupplier">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<script>
    import mintSelect from '../../components/mintSelect.vue'

    export default{

        components: {
            'mint-select':mintSelect
        },

        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,

                name:'',
                ps:'',
                phone:'',
                type:'',
                typeSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],
            }
        },
        methods:{

            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },

            createSupplier(){

                if(this.name===''||this.type===''){
                    this.$toast('带*为必填项');
                    return false;
                }

                this.$indicator.open('加载中');
                let that = this;

                this.$axios.post("/my/supplier", {openid:this.openid,name:this.name,phone:this.phone,type:this.type,ps:this.ps})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('添加成功!');
                            that.$router.push('/my');
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            }

        },

        created(){
            this.$indicator.open('加载中');

            this.$axios.get("/my/supplierType?openid="+this.openid)
                .then(data => {

                    this.$indicator.close();

                    if (data.data.code === 'OK') {
                        this.typeSlots[0].values = data.data.data;
                    } else {
                        this.$toast(data.data.message);
                    }
                });
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/my/supplier.vue